function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import StoreFilters from "./storeFilters.class";
import { Constants as CONSTANTS } from "./commons/list.constants.class";
import { pushTmsEvent } from "./tracking.function";
import Modal from "@mozaic-ds/freemarker/js/modules/_modal";
var PedagogicalFilters = /*#__PURE__*/function (_StoreFilters) {
  function PedagogicalFilters(config) {
    var _this;
    _classCallCheck(this, PedagogicalFilters);
    _this = _callSuper(this, PedagogicalFilters, [config]);
    try {
      if (config.event === undefined || config.event == null) throw new Error("CLass PedagogicalFilters need event in parameters");
      _this.form = document.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.SELECTOR));
      _this.selectedPedagogicalFilters = _this.initSelectedFilters();
      _this.validatedPedagogicalFilters = _objectSpread({}, _this.selectedPedagogicalFilters);
      if (_this.form) {
        _this.currentPedagogicalFilterCode = _this.form.dataset.pedagogicalFilterCode;
        _this.validateButton = _this.form.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.VALIDATE_BUTTON));
        _this.resetButton = _this.form.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.RESET_BUTTON));
        _this.previousButton = _this.form.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.PREVIOUS_BUTTON));
        _this.skipButton = _this.form.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.SKIP_BUTTON));
        _this.hasAlreadySelectedValues = _this.selectedPedagogicalFilters[_this.currentPedagogicalFilterCode] && _this.selectedPedagogicalFilters[_this.currentPedagogicalFilterCode].length > 0;
        _updateValidateButtonDisableState.call(_this);
        _this.initEvent();
        _this.initModal();
      }
    } catch (err) {
      console.log("Error class PedagogicalFilters", err);
    }
    return _this;
  }

  /**
   * init event of select of PedagogicalFilters
   */
  _inherits(PedagogicalFilters, _StoreFilters);
  return _createClass(PedagogicalFilters, [{
    key: "initEvent",
    value: function initEvent() {
      _initButtonsEvent.call(this);
      _initCheckboxEvents.call(this);
    }
  }, {
    key: "initModal",
    value: function initModal() {
      if (document.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.DESCRIPTION_MODAL.CONTENT))) {
        var modal = new Modal({
          classContent: CONSTANTS.PEDAGOGICAL_FILTERS.DESCRIPTION_MODAL.CONTENT
        });
        var openModalButton = document.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.DESCRIPTION_MODAL.OPEN_BUTTON));
        var closeModalButton = document.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.DESCRIPTION_MODAL.CLOSE_BUTTON));
        openModalButton.addEventListener("click", function () {
          modal.open();
        });
        closeModalButton.addEventListener("click", function () {
          modal.close();
        });
      }
    }
  }, {
    key: "initSelectedFilters",
    value: function initSelectedFilters() {
      var searchParams = new URLSearchParams(window.location.search);
      var pedagogicalFiltersParams = searchParams.get("pedagogicalFilters");
      var selectedPedagogicalFilters = {};
      if (pedagogicalFiltersParams) {
        var pedagogicalFilters = JSON.parse(pedagogicalFiltersParams);
        return Object.keys(pedagogicalFilters).reduce(function (selected, currentPedagogicalFilterCode) {
          var notSplittedValues = pedagogicalFilters[currentPedagogicalFilterCode];
          var splittedValues = notSplittedValues.split("#|");
          return _objectSpread(_objectSpread({}, selected), {}, _defineProperty({}, currentPedagogicalFilterCode, splittedValues));
        }, {});
      }
      return selectedPedagogicalFilters;
    }
  }]);
}(StoreFilters);
export default PedagogicalFilters;
function _initButtonsEvent() {
  if (this.validateButton) {
    this.validateButton.addEventListener("click", _validateForm.bind(this));
  }
  if (this.previousButton) {
    this.previousButton.addEventListener("click", _previousQuestion.bind(this));
  }
  if (this.skipButton) {
    this.skipButton.addEventListener("click", _skipQuestion.bind(this));
  }
  if (this.resetButton) {
    this.resetButton.addEventListener("click", _resetPedagogicalFilters.bind(this));
  }
}
function _initCheckboxEvents() {
  var _this2 = this;
  var checkBoxInputs = this.form.querySelectorAll("input[type=checkbox]");
  if (checkBoxInputs.length > 0) {
    checkBoxInputs.forEach(function (checkboxInput) {
      checkboxInput.addEventListener("change", _updateSelectedPedagogicalFilters.bind(_this2));
    });
  }
}
function _validateForm() {
  this.validatedPedagogicalFilters = _objectSpread({}, this.selectedPedagogicalFilters);
  this.dispatch({
    action: CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE,
    filters: {
      pedagogicalFilters: this.validatedPedagogicalFilters
    }
  });
}
function _skipQuestion() {
  this.dispatch({
    action: CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.SKIP,
    filters: {
      pedagogicalFilters: this.validatedPedagogicalFilters
    }
  });
}
function _previousQuestion() {
  this.dispatch({
    action: CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.BACK,
    filters: {
      pedagogicalFilters: this.validatedPedagogicalFilters
    }
  });
}
function _resetPedagogicalFilters() {
  this.dispatch({
    action: CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.RESET,
    filters: {
      pedagogicalFilters: this.validatedPedagogicalFilters
    }
  });
}
function _updateSelectedPedagogicalFilters(evt) {
  var _evt$target = evt.target,
    name = _evt$target.name,
    checked = _evt$target.checked,
    value = _evt$target.value;
  this.selectedPedagogicalFilters[name] = this.selectedPedagogicalFilters[name] || [];
  if (checked) {
    this.selectedPedagogicalFilters[name] = [].concat(_toConsumableArray(this.selectedPedagogicalFilters[name]), [value]);
  } else {
    this.selectedPedagogicalFilters[name] = this.selectedPedagogicalFilters[name].filter(function (item) {
      return item !== value;
    });
  }
  if (this.selectedPedagogicalFilters[name].length === 0) {
    delete this.selectedPedagogicalFilters[name];
  }
  _updateValidateButtonDisableState.call(this);
  pushTmsEvent(evt.target, "list.filter", {
    filter_type: "pedagogical filter",
    filter_value: evt.target.value,
    filter_selection: evt.target.checked ? "selected" : "deselected"
  });
}
function _updateValidateButtonDisableState() {
  if (this.validateButton) {
    var currentPedagogicalFilterValues = this.selectedPedagogicalFilters[this.currentPedagogicalFilterCode];
    var hasCurrentlySelectedValues = currentPedagogicalFilterValues && currentPedagogicalFilterValues.length > 0;
    this.validateButton.disabled = !this.hasAlreadySelectedValues && !hasCurrentlySelectedValues;
  }
}